import { useApi } from 'services';

export const useGetPersonRole = (idOperation) => useApi(`v2/operation/${idOperation}/person-role`, 'GET', {}, {}, true);
